"use client";
import BookingTermsContentTh from "./BookingTermsContent.th";
import BookingTermsContentEn from "./BookingTermsContent.en";

export default function BookingTermsContent({ lang = "th" }: { lang?: "th" | "en" }) {
  if (lang === "en") return <BookingTermsContentEn />;
  return <BookingTermsContentTh />;
}